module.exports = __webpack_public_path__ + "img/logotypy_eu.d8026883.jpg";